import React from 'react';
import { Box, Typography, Button } from '@material-ui/core';
import { Link } from "react-router-dom";
import Search from '../search';
import { makeStyles } from '@material-ui/core/styles';
import Plus from '../assets/icons/white-plus.png'
const useStyles = makeStyles(theme => ({

    TitleUser: {
        fontFamily: 'UniviaPro-Medium',
        fontSize: '18px',
        fontWeight: 500,
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.2,
        letterSpacing: 'normal',
        color: '#4f5064',
    },

    textbtnCreate: {
        fontFamily: 'UniviaPro-Bold',
        fontSize: '9px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 1.22,
        letterSpacing: '0.36px',
        color: '#ffffff',
    },
    subText: {
        fontFamily: 'UniviaPro-Medium',
        fontWeight: '500',
        lineHeight: "13.2px",
        marginLeft: 10,
        letterSpacing: 'normal',
        color: '#88898c',
        fontSize: 11
    }

}))

const PageListLabel = ({ searchHidden, searchPlaceholder, label, btnText, buttonHidden, pathname, onChangeText, getList, total }) => {
    const classes = useStyles();
    return (
        <Box display="flex" py={3}>
            <Box my='auto' display="flex" flexDirection="row" alignItems="center">
                <Typography className={classes.TitleUser} color="textPrimary">{label}</Typography>
                {
                    total > 0 ? <Typography className={classes.subText}>({total})</Typography>
                        : <Typography className={classes.subText}>(0)</Typography>
                }
            </Box>
            <Box flexGrow={1} display='flex' justifyContent='flex-end'>
                {
                    !searchHidden && <Search
                        placeholder={searchPlaceholder}
                        onChangeText={onChangeText}
                        getList={getList}
                    />
                }

                {
                    !buttonHidden && <Box display='flex' justifyContent='flex-end' my='auto' ml={4}>
                        <Button
                            variant="contained"
                            color='primary'
                            endIcon={<img src={Plus} style={{ width: "18px", height: 18 }} />}
                            component={Link}
                            to={{ pathname }}
                        >
                            <Typography className={classes.textbtnCreate}>{btnText}</Typography>
                        </Button>


                    </Box>
                }
            </Box>
        </Box>
    );
}

export default PageListLabel;
